import { useEffect, useState } from "react";
import {
  getConnectionKeys,
  getConnectionKeysByFilter,
} from "../services/connectionKeysService";

interface FetchConnectionKeyByFiltersParams {
  filterKeys?: any;
  setIsLoading: (loading: boolean) => void;
  type?: string;
  system_id?: number;
}
const useFetchConnectionKeyByFilter = ({
  filterKeys,
  setIsLoading,
  type,
  system_id,
}: FetchConnectionKeyByFiltersParams) => {
  const [connectionKeysByFiltersData, setConnectionKeysByFiltersData] =
    useState<any[]>([]);
  useEffect(() => {
    const getConnectionKeysByFiltersData = async () => {
      setIsLoading(true);
      try {
        const result = await getConnectionKeysByFilter(
          type,
          filterKeys,
          system_id
        );
        setConnectionKeysByFiltersData(result);
      } catch (err) {
        setConnectionKeysByFiltersData([]);
      } finally {
        setIsLoading(false);
      }
    };
    (filterKeys?.length > 0 || type || (system_id && system_id > 0)) &&
      getConnectionKeysByFiltersData();
  }, [filterKeys, type, system_id]);

  return [connectionKeysByFiltersData];
};

export default useFetchConnectionKeyByFilter;
